// Single source of truth for the app owner's email (admin gating).
// Used by the frontend (Sidebar nav gate) AND api/_shared (marketing-handler auth).
// NOTE: the DB RLS policy in supabase/migrations/marketing_agent.sql hardcodes
// this same value — SQL can't import, so keep that literal in sync with this.
export const OWNER_EMAIL = 'zahitach@gmail.com';
